import React from 'react';
import { Box } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import ApplicationFileTypeItem from './ApplicationFileTypeItem.tsx';
import ApplicationFilesLoading from './ApplicationFilesLoading.tsx';
import type { TApplicationFilesContentProps } from './types.ts';

const ApplicationFilesContent: React.FC<TApplicationFilesContentProps> = ({
  activeAction = null,
  fileTypes,
  isLoading = false,
  onDelete,
  onDownload,
  onRegenerate,
  onUpload,
}) => {
  const content =
    isLoading && !fileTypes.length ? (
      <ApplicationFilesLoading />
    ) : (
      <Box sx={guaranteesClientPageStyles.applicationFilesList}>
        {fileTypes.map((capability) => (
          <ApplicationFileTypeItem
            key={capability.fileType}
            capability={capability}
            activeAction={activeAction}
            onUpload={onUpload}
            onRegenerate={onRegenerate}
            onDownload={onDownload}
            onDelete={onDelete}
          />
        ))}
      </Box>
    );

  return content;
};

export default ApplicationFilesContent;
